import { createRouter, createWebHistory } from 'vue-router'
import authGuard from '@/utils/authGuard.js'


import qwUserLabelRouter from "./modules/qiwei"
import userRouter from "./modules/user"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/userLabel/index',
    },
    ...qwUserLabelRouter,
    ...userRouter,
    {
      path: '/404',
      name: '404',
      component: () => import('../views/404.vue'),
      meta: { title: '页面不存在', noAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  },
})

router.beforeEach(async (to, _from, next) => {
  console.log('to', to)
  document.title = to.meta.title
  const action = await authGuard(to)
  // 'callback' | 'next' → 放行；'redirect' → 已跳转，无需操作
  if (action !== 'redirect') next()
})

export default router
